import React from "react";
import "./ColorSchemeSelector.css";
import {ColorSchemeList} from "../../assets/ColorSchema";


type ColorSchemeSelectorProps = {
    className?: string;
    onChange?: (color_scheme: string) => void;
}

export const ColorSchemeSelector = (props: ColorSchemeSelectorProps) => {
    return (
        <ul className={`color-scheme-selector ${props.className}`}>
            {ColorSchemeList.map(
                scheme => (
                    <li key={scheme.Key} onClick={() => props.onChange?.(scheme.Key)}>
                        <div style={{backgroundColor: scheme.RoleColor}}/>
                        <div style={{backgroundColor: scheme.GroupColor}}/>
                        <div style={{backgroundColor: scheme.FunnelColor}}/>
                    </li>
                )
            )}
        </ul>
    );
}

